import { render, staticRenderFns } from "./cusSecond.vue?vue&type=template&id=b4fa099c&scoped=true"
import script from "./cusSecond.vue?vue&type=script&lang=js"
export * from "./cusSecond.vue?vue&type=script&lang=js"
import style0 from "./cusSecond.vue?vue&type=style&index=0&id=b4fa099c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fa099c",
  null
  
)

export default component.exports